import useForm from 'hooks/useForm';
export function useAutoJoinForm(_ref) {
  var isAutoJoinEnabled = _ref.isAutoJoinEnabled,
    autoJoinSettings = _ref.autoJoinSettings;
  return useForm({
    fields: {
      meetingType: {
        getDefaultValue: function getDefaultValue() {
          return (autoJoinSettings === null || autoJoinSettings === void 0 ? void 0 : autoJoinSettings.meeting_type) || 'all';
        }
      },
      onlyMeetingsIOrganise: {
        getDefaultValue: function getDefaultValue() {
          return (autoJoinSettings === null || autoJoinSettings === void 0 ? void 0 : autoJoinSettings.only_meetings_I_organise) || false;
        }
      },
      isAutoJoinEnabled: {
        getDefaultValue: function getDefaultValue() {
          return isAutoJoinEnabled || false;
        }
      }
    }
  });
}